import React, { Fragment, useContext, useEffect, useState } from "react";

import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { MdShare } from "react-icons/md";
import notifyContext from "../../../Context/notifyContext";
import navContext from "../../../Context/navContext";
import { findAll } from "../../../../services/Client__Service";
import Modal from "../../../Modal/Modal";
import Form from "../Client/components/Form/Form";

const ListClientDocPaie = () => {
  const redirect = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        field: "Image",
        headerName: "",
        valueGetter: (params) => {
          return params.row.chemin ? params.row.chemin : null;
        },
        cellClassName: "img-data-grid",
        renderCell: (params) =>
          params.value && (
            <img className="img-data-grid" src={params.value} alt="" />
          ),
      },
      { field: "sigle", headerName: "Sigle", width: 110, editable: true },
      { field: "nom", headerName: "Nom", width: 250, flex: 2, editable: true },
      {
        field: "email",
        headerName: "Email",
        width: 150,
        flex: 1,
        valueGetter: (params) => {
          return `${params.row.email1}`;
        },
      },
      {
        field: "telephone",
        headerName: "Téléphone",
        width: 150,
        valueGetter: (params) => {
          return `${params.row.tel1}`;
        },
      },
      { field: "statut", headerName: "Statut", type: "boolean", width: 120 },
      {
        field: "actions",
        headerName: "Ouvrir",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdShare />}
            label="Ouvrir"
            onClick={() => {
              redirect("/main/client/" + params.id + "/share/");
            }}
          />,
        ],
      },
    ],
    [redirect]
  );

  const notify = useContext(notifyContext);
  const [viewClientId, setViewClientId] = useState(0);
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);

  useEffect(() => {
    nav({
      links: [
        {
          href: "/main/docpaie",
          linkname: "Docs. Paie",
        },
      ],
      children: "",
    });
    fetchAllClient();
  }, []);

  const fetchAllClient = async () => {
    findAll()
      .then((response) => {
        setClients(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="client__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={clients}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>

      {viewClientId !== 0 && (
        <Modal>
          <div className={`modal ${viewClientId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Client</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewClientId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <Form clientId={viewClientId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewClientId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListClientDocPaie;
